// extracted by mini-css-extract-plugin
var _1 = "LabelsStep_droppableHack__deQ72";
var _2 = "LabelsStep_items__cZWCM";
export { _1 as "droppableHack", _2 as "items" }
